import * as GS from '../ProductDetail.styles';

type DescriptionProps = {
  description: string;
  withBorderBottom?: boolean;
};

export const Description = ({
  description,
  withBorderBottom,
}: DescriptionProps) => {
  return (
    <GS.Description
      data-test-id='Description'
      withBorderBottom={withBorderBottom}
    >
      {description}
    </GS.Description>
  );
};
